import { extendBaseTheme } from "@chakra-ui/react";

const customTheme = {
  components: {},
  colors: {
    primary: {
      500: "#C9A84C",
    },
    secondary: {
      50: "#F5EDD6",
      100: "#E8D5A3",
      300: "#D4B870",
      500: "#C9A84C",
    },
    neutral: {
      0: "#FFFFFF",
      10: "#C6C6C6",
      20: "#B0B0B0",
      50: "#8C8C8C",
      100: "#F9F9F9",
      150: "#F4F4F7",
      200: "#EAEAEA",
      300: "#BCBCBC",
      350: "#696969",
      400: "#353535",
      500: "#2F2F2F",
      600: "#363843",
      700: "#171717",
    },
    fail: {
      300: "#ff6663",
      500: "#eb0909",
    },
    blue: {
      700: "#5A77FF",
      800: "#375CFF",
    },
  },
};

export const theme = extendBaseTheme(customTheme);
